module.exports = __webpack_public_path__ + "img/banner3.cd98517b.jpg";